import React, { Component } from 'react';
import * as constClass from '../constants/agent.js';

import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Spinner from 'react-bootstrap/Spinner';

import DatePicker from "react-datepicker";


// For now this form expects all data need by the flightticket-pdf-backend
// to be passed as props.

class NameEmailForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      first_name: '',
      last_name: '',
      birthdate: '',
      email: '',
      subscribe_to_newsletter: true, // Equals false. Set to "on" when user clicks box
      downloading: false,
      show_modal: false,
      errors: {
        first_name: '',
        last_name: '',
        email: '',
        birthday: '',
        valid: {
          first_name: false,
          last_name: false,
          email: false,
          birthday: false,
        }
      }
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange = name => event => {
    if (name === "first_name") {
      this.validateFirstName(event.target.value);
    }

    else if (name === "last_name") {
      this.validateLastName(event.target.value);
    }

    else if (name === "email" ) {
      this.validateEmail(event.target.value);
    }

    else if (name === "birthdate" ) {
      this.validateBirthdate(event.target.value);
    }

    this.setState({[name]: event.target.value});
  }

  handleCheckboxChange = name => event => {
    this.setState({[name]: event.target.checked})
  }


// Form validation functions

  validateFirstName = name => {
    //ToDo Maybe just validate length here
    if (name.length < 2) {
      let errors = {...this.state.errors}
      errors.first_name = 'Please enter your first name.'
      errors.valid.first_name = false
      this.setState({errors})
    }
    else {
      let errors = {...this.state.errors}
      errors.first_name = ''
      errors.valid.first_name = true
      this.setState({errors})
    }
  }

  validateLastName = name => {
    //ToDo Maybe just validate length here
    if (name.length < 2) {
      let errors = {...this.state.errors}
      errors.last_name = 'Please enter your last name.'
      errors.valid.last_name = false
      this.setState({errors})
    }
    else {
      let errors = {...this.state.errors}
      errors.last_name = ''
      errors.valid.last_name = true
      this.setState({errors})
    }
  }


  validateEmail = email => {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if  (re.test(String(email).toLowerCase()) === false) {
      let errors = {...this.state.errors}
      errors.email = 'Please enter a valid e-mail address.'
      errors.valid.email = false
      this.setState({errors})
    }
    else {
      let errors = {...this.state.errors}
      errors.email = ''
      errors.valid.email = true
      this.setState({errors})
    }
  }

  parseDate = dateObj => {
    if (dateObj === null) {
      return null
    }

    const month = dateObj.getUTCMonth() + 1; //months from 1-12
    const day = dateObj.getDate();
    const year = dateObj.getUTCFullYear();

    const birthdate = month + "-" + day + "-" + year;

    return birthdate
  }

  validateBirthday = dateObj => {

    const birthdate = this.parseDate(dateObj);
    console.log("[validateBirthday]");
    console.log(birthdate);
    const re = /^\d{1,2}[./-]\d{1,2}[./-]\d{4}$/
    if  (re.test(String(birthdate).toLowerCase()) === false || birthdate === null) {
      let errors = {...this.state.errors}
      errors.birthdate = 'Please enter your birthdate using the widget.'
      errors.valid.birthdate = false
      this.setState({errors});
    }
    else {
      let errors = {...this.state.errors}
      errors.birthdate = ''
      errors.valid.birthdate = true
      this.setState({errors});
      return true
    }
  }

  enableSubmitButton = () => {
    if (
      this.state.errors.valid.first_name === true &&
      this.state.errors.valid.last_name === true &&
      this.state.errors.valid.email === true &&
      this.state.errors.valid.birthdate === true
    ) {
      return true
    } else {
      return false
    }
  }


  async handleSubmit(event) {
    this.handleShowModal();
    event.preventDefault();
    const first_name = event.target.elements[0].value; // TODO Should use this.state
    const last_name = event.target.elements[1].value; // TODO Should use this.state
    const email = event.target.elements[2].value; // TODO Should use this.state
    const birthdate = event.target.elements[3].value; // TODO Should use this.state
    const subscribe_to_newsletter = event.target.elements[4].checked // TODO Should use this.state
    const flight_name = this.props.data.airlines[0]
    const departure_time = this.props.data.local_departure
    const arrival_time = this.props.data.local_arrival
    const fly_to = this.props.data.flyTo
    const fly_from = this.props.data.flyFrom
    const city_to = this.props.data.cityTo
    const city_from = this.props.data.cityFrom
    const price = this.props.data.price
    const fly_duration = this.props.data.duration.total
    const route = this.props.data.route
    const airline = this.props.data.airlines[0]


    //const FLIGHT_PDF_URL = 'http://localhost:8000/ticket/hello.pdf'
    //const HEROKU_CORS = 'https://warm-cliffs-24424.herokuapp.com/'

    console.log("Will request the PDF")
    this.setState({downloading: true});
    const url = constClass.IS_LOCAL_INSTANCE ? constClass.FLIGHT_PDF_LOCAL_BACKEND_URL : constClass.FLIGHT_PDF_BACKEND_URL;
    const response = await fetch(url,
      {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      responseType: "blob",
      body: JSON.stringify(
        {
          first_name: first_name,
          last_name: last_name,
          email: email,
          birthdate: birthdate,
          subscribe_to_newsletter: subscribe_to_newsletter,
          flight_name: 'bester flug',
          departure_time: departure_time,
          arrival_time: arrival_time,
          departure_time: departure_time,
          fly_to: fly_to,
          fly_from: fly_from,
          city_from: city_from,
          city_to: city_to,
          price: price,
          fly_duration: fly_duration,
          route: route,
          airline: airline
        })
      }
    );

    // Retrieve a Blob object
    const blob = await response.blob()

    //Build a URL from the file
    const fileURL = URL.createObjectURL(blob);

    // Open file in browser
    // For download set the third parameter to true
    this.downloadFile(blob, `booking_confirmation_${fly_from}_${fly_to}.pdf`, false);
    this.setState({downloading: false});

    //alert('A name was submitted: ');
  }

  downloadFile = (blob, fileName, openInBrowser=true) => {
    const link = document.createElement('a');
    // create a blobURI pointing to our Blob
    link.href = URL.createObjectURL(blob);
    if (!openInBrowser) {
      link.download = fileName;
    }
    // some browser needs the anchor to be in the doc
    document.body.append(link);
    // Start download
    link.click();
    // Clean up and remove the link
    link.remove();
    // in case the Blob uses a lot of memory
    window.addEventListener('focus', e=>URL.revokeObjectURL(link.href), {once:true});
  };

  ////////////////////////////////////////////////////////////////////////
  // Modal functions
  handleCloseModal = () => this.setState({show_modal: false})
  handleShowModal = () => this.setState({show_modal: true})
  ////////////////////////////////////////////////////////////////////////

  render() {
    const download_button = this.state.downloading ?
     <button class="btn btn-primary" type="button" disabled>
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        Creating Ticket...
      </button>
      :
      <button class="btn btn-primary" type="submit" disabled={this.enableSubmitButton() === true ? false : true }>Get Flightticket!</button>

      // Only start validating after the user put in at least two charachters.
      const firstName_input = this.state.first_name.length <= 2 ?
        <div className="form-group">
            <label for="firstName">First Name</label>
            <input type="text" id="firstName" value={this.state.first_name} onChange={this.handleChange("first_name")} class="form-control" placeholder="John" />
        </div>
        :
        <div className="form-group">
            <label for="firstName">First Name</label>
            <input type="text" id="firstName" value={this.state.first_name} onChange={this.handleChange("first_name")} class={this.state.errors.valid.first_name ? "form-control is-valid" : "form-control is-invalid"} placeholder="John" />
            <div class="invalid-feedback">
              {this.state.errors.first_name}
            </div>
        </div>

        // Only start validating after the user put in at least two charachters.
      const lastName_input = this.state.last_name.length <= 2 ?
        <div className="form-group">
          <label for="familyName">Last Name</label>
          <input type="text" id="familyName" value={this.state.last_name} onChange={this.handleChange("last_name")} class="form-control" placeholder="Doe" />
        </div>
        :
        <div className="form-group">
          <label for="familyName">Last Name</label>
          <input type="text" id="familyName" value={this.state.last_name} onChange={this.handleChange("last_name")} class={this.state.errors.valid.last_name ? "form-control is-valid" : "form-control is-invalid"} placeholder="Doe" />
          <div class="invalid-feedback">
            {this.state.errors.last_name}
          </div>
        </div>

      // Only start validating after the user put in at least two charachters.
      const email_input = this.state.email.length <= 0 ?
        <div className="form-group">
          <label for="email">Email</label>
          <input type="email" id="email" value={this.state.email} onChange={this.handleChange("email")} class="form-control" placeholder="Enter email"/>
        </div>
        :
        <div className="form-group">
          <label for="email">Email</label>
          <input type="email" id="email" value={this.state.email} onChange={this.handleChange("email")} class={this.state.errors.valid.email ? "form-control is-valid" : "form-control is-invalid"} placeholder="Enter email"/>
          <div class="invalid-feedback">
            {this.state.errors.email}
          </div>
        </div>

      const birthdate_input =
        <div className="form-group">
          <label for="firstName">Birthdate</label>
          <div className="row">
            <div className="col">
              <DatePicker
                onChange = {birthdate => {
                  console.log("onChange Datepicker");
                  this.validateBirthday(birthdate);
                  this.setState({birthdate: birthdate});
                }}
                selected = {this.state.birthdate}
                dateFormat="yyyy-MM-dd"
                className={this.state.birthdate === null ? "form-control" : (this.state.birthdate.length === 0  ? "form-control" : (this.state.errors.valid.birthdate ? "form-control is-valid" : "form-control is-invalid"))}
                placeholderText="Birthdate"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
              />
            </div>
          </div>
        </div>

        const subscribe_to_newsletter =
          <div className="form-group">
            <input type="checkbox" className="form-check-input" id="subscribe_to_newsletter" checked={this.state.subscribe_to_newsletter} onChange={this.handleCheckboxChange("subscribe_to_newsletter")}/>
            <label className="form-check-label" htmlFor="subscribe_to_newsletter">Subscribe to newsletter</label>
          </div>

        ////////////////////////////////////////////////////////////////////////
        // Modal Component after download

        const modal_body_download_pending =
        <div class="col-md-12">
          <p>We are generating your <strong>personalized dummy ticket</strong>.</p>
          <p>Please wait a few seconds.</p>
          <h1>
            <Spinner animation="grow" variant="primary" />
            <Spinner animation="grow" variant="secondary" />
            <Spinner animation="grow" variant="success" />
            <Spinner animation="grow" variant="danger" />
            <Spinner animation="grow" variant="warning" />
            <Spinner animation="grow" variant="info" />
          </h1>
        </div>

        const modal_body_download_finished =
        <div class="col-md-6">
          <h1>
            <svg xmlns="http://www.w3.org/2000/svg" fill="green" width="100%" class="bi bi-check-circle" viewBox="0 0 16 16">
              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
              <path d="M10.97 4.97a.235.235 0 0 0-.02.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05z"/>
            </svg>
          </h1>
        </div>
        const debug_modal_button =
          <Button variant="primary" onClick={this.handleShowModal}>
            Launch demo modal
          </Button>

        const download_modal =
        <div>
          <Modal
            show={this.state.show_modal}
            onHide={this.handleCloseModal}
            size="sm"
            closeButton
          >
            <Modal.Header>
              <Modal.Title>
                {this.state.downloading && "Downloading your ticket.."}
                {!this.state.downloading && "Download finished!"}
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div class="container" >
                  <div class="row justify-content-center">
                    {this.state.downloading && modal_body_download_pending}
                    {!this.state.downloading && modal_body_download_finished}
                  </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <h4>Will you please rate us on Trustpilot?</h4>
              <div className="container-fluid">
                <div className="row justify-content-left">
                  <div className="col">
                    <Button
                      variant="primary"
                      href="https://www.trustpilot.com/review/onwardflightticket.com"
                      target="_blank"
                    >
                      Yes, sure!
                    </Button>
                  </div>
                  <div className="col">
                    <Button variant="secondary" onClick={this.handleCloseModal}>
                      Not now
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Footer>
          </Modal>
        </div>

        ////////////////////////////////////////////////////////////////////////

    return (
      <div className="container-fluid">
        <div className="row justify-content-left">
          <div className="col-lg-4">
            <form onSubmit={this.handleSubmit}>
              {firstName_input}
              {lastName_input}
              {email_input}
              {birthdate_input}
              {subscribe_to_newsletter}
              {download_button}
              {/*debug_modal_button*/}
            </form>
          </div>
          <br/>
        </div>
        {download_modal}
      </div>

    );
  }
}

export default NameEmailForm;
